import { render, staticRenderFns } from "./WorkspaceDetailsTab.vue?vue&type=template&id=dac70f20&scoped=true"
import script from "./WorkspaceDetailsTab.vue?vue&type=script&lang=js"
export * from "./WorkspaceDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDetailsTab.vue?vue&type=style&index=0&id=dac70f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac70f20",
  null
  
)

export default component.exports